import { Alert, AlertIcon, AlertDescription } from '@/components/v4';

/**
 * @param {import('@chakra-ui/react').AlertProps} props
 */
function AlertField({ status, message, className, ...props }) {
    return (
        <Alert status={status} variant="inline-accent" {...props}>
            <AlertIcon />
            <AlertDescription className={className}>{message}</AlertDescription>
        </Alert>
    );
}

export { AlertField };
